import { isDarkTheme, Themes } from '@/constants/Colors';

// Authenticated Business UI follows the resolved app palette, including custom
// colors and accessibility overrides. The public website has its own palette.
export function businessAppTheme(colors = {}, theme = 'white') {
  const palette = { ...(Themes[theme] || Themes.white), ...colors };
  return {
    colorScheme: isDarkTheme(theme) ? 'dark' : 'light',
    '--gb-ink': palette.text_color_primary,
    '--gb-muted': palette.text_color_secondary,
    '--gb-rule': palette.border_color_secondary,
    '--gb-fill': palette.solid_color_tertiary,
    '--gb-surface': palette.solid_color_primary,
    '--gb-field': palette.solid_color_tertiary,
    '--gb-error': palette.color_destructive,
  };
}
